/*!

 =========================================================
 * Vue Now UI Kit Pro - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/vue-now-ui-kit-pro
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
//import GAuth from 'vue-google-oauth2'
import Vuex from 'vuex'
import LoadScript from 'vue-plugin-load-script';
import VueScrollTo from 'vue-scrollto';

import store from './store/store'
//import videosJson from './sarel/videos.json';

import VueMeta from 'vue-meta';
Vue.use(VueMeta);

require('./bootstrap');

//plugins
import NowUIKit from './plugins/now-ui-kit';

import User from './helpers/User'
window.User = User

Vue.config.productionTip = false;
Vue.use(NowUIKit);

/*const gauthOption = {
  clientId: '447652890745-s1c4dn090v9rssh1bdn6och3qrf156rg.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)*/

Vue.use(VueScrollTo)

Vue.use(Vuex)

Vue.use(LoadScript)

new Vue({
  store,
  router,
  render: h => h(App),
  /*created() {
    this.$store.dispatch('init', {})
  }*/

}).$mount("#app");
